export default __webpack_public_path__ + "static/media/sports (5).9be41d4f.jpg";